var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportCaseAnalysisBelow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 87"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon 10",
    d: "M5.07793 11.3354C5.27433 11.6447 5.72567 11.6447 5.92207 11.3354L9.77536 5.26805C9.98677 4.93517 9.74763 4.5 9.35328 4.5H1.64672C1.25238 4.5 1.01323 4.93517 1.22464 5.26805L5.07793 11.3354Z",
    fill: "#EE0000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 26",
    width: 3,
    height: 5,
    rx: 0.5,
    transform: "matrix(1 0 0 -1 4 5)",
    fill: "#EE0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportCaseAnalysisBelow);
export default __webpack_public_path__ + "static/media/report_caseAnalysis_below.40289f3f21403398e0be3c188a30cfac.svg";
export { ForwardRef as ReactComponent };